import React from 'react';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { WebsiteEditorPhotoComponentFragment } from '@graphql/generated';
import { PhotoAddEditProps } from '../../Photo.types';
import { PhotoUpload } from '../../components/PhotoUpload';
import { WebsiteEditorPhotoTelemetryProvider } from '../../Photo.telemetry';

export const PhotoAddEdit: React.FC<PhotoAddEditProps> = props => {
  const { customComponentBlockData: photoData } = useCustomComponentStateContext<WebsiteEditorPhotoComponentFragment>();
  return (
    <WebsiteEditorPhotoTelemetryProvider>
      <PhotoUpload
        {...props}
        photoData={photoData}
      />
    </WebsiteEditorPhotoTelemetryProvider>
  );
};
